import { useState, useRef } from "react";
import { Box, IconButton, MenuItem, Dialog } from "@mui/material";
import {
  Visibility as ViewIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import MaterialReactTable from "material-react-table";
import {
  ViewDevice,
  useGetPatientDevices,
  useDissociateFromPatient,
} from "../../DeviceComponents";
import {
  LoadingPaper,
  EmptyPaper,
  LoadingError,
} from "../../LoadingComponents";
import columns from "./DispositiviColumns";

export default function DispositiviPatient({ patient_id }) {
  // === misc ===
  const tableColumns = columns;

  // === ViewDevice modal handling ===
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [openViewDevice, setOpenViewDevice] = useState(false);
  const handleOpenViewDevice = (dev) => {
    setSelectedDevice(dev);
    setOpenViewDevice(true);
  };
  const handleCloseViewDevice = () => {
    setOpenViewDevice(false);
  };
  const openInEditMode = useRef(false);

  // === web service queries ===
  const patientDevicesQuery = useGetPatientDevices(patient_id);
  const dissociateMutation = useDissociateFromPatient();

  const handleDissociateFomPatient = (id) => {
    console.log("Dissociating device with ID: ", id);
    dissociateMutation.mutate({
      id: id,
    });
  };

  return (
    <Box
      sx={{
        display: "block",
        margin: "auto",
        width: "90%",
      }}
    >
      <Dialog open={openViewDevice} fullScreen>
        <ViewDevice
          device_id={selectedDevice}
          closeModal={handleCloseViewDevice}
          _editMode={openInEditMode.current}
        />
      </Dialog>

      {patientDevicesQuery.isLoading ? (
        <LoadingPaper />
      ) : patientDevicesQuery.isError ? (
        <LoadingError error={patientDevicesQuery.error} />
      ) : (
        patientDevicesQuery.isSuccess &&
        (patientDevicesQuery.data.devices.length === 0 ? (
          <EmptyPaper message="Nessun dispositivo associato al paziente" />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={patientDevicesQuery.data?.devices || []}
            enableColumnActions={false}
            enableColumnFilters={false}
            enablePagination={false}
            enableSorting={false}
            enableBottomToolbar={false}
            enableTopToolbar={false}
            muiTableBodyRowProps={{ hover: false }}
            muiTablePaperProps={{ elevation: 0 }}
            enableRowActions={true}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Azioni" },
            }}
            positionActionsColumn="last"
            renderRowActionMenuItems={({ closeMenu, row, table }) => [
              <MenuItem
                key="view"
                onClick={() => {
                  openInEditMode.current = false;
                  handleOpenViewDevice(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  <ViewIcon color="primary" />
                </IconButton>
                Visualizza
              </MenuItem>,

              <MenuItem
                key="edit"
                onClick={() => {
                  openInEditMode.current = true;
                  handleOpenViewDevice(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  <EditIcon color="warning" />
                </IconButton>
                Modifica
              </MenuItem>,

              <MenuItem
                key="delete"
                onClick={() => {
                  console.log("dissociating");
                  handleDissociateFomPatient(row.original.id);
                  closeMenu();
                }}
              >
                <IconButton>
                  <DeleteIcon color="error" />
                </IconButton>
                Rimuovi
              </MenuItem>,
            ]}
          />
        ))
      )}
    </Box>
  );
}
